import { Autocomplete, TextField } from "@mui/material"
import { useFieldPrefix } from "components/form/input/NestedField"
import { useCallback, useEffect, useState } from "react"
import { Field } from "react-final-form"
import Cliente from 'entity/Cliente'
import { fetchArray } from "entity"

export default function SeletorMultiploClientes({
    agrupador,
    cliente,
    change,
    perfil,
    setTipoPerfil,
    tipoPerfil
}) {
    const [clienteList, setClienteList] = useState([])
    const clienteFieldName = useFieldPrefix('cliente')
    const [open, setOpen] = useState(false)
    const loading = open && clienteList.length === 0

    const loadOptions = useCallback(async () => {
        let query = await Cliente.query()

        const extraQuery = (col) => {
            if (perfil) {
                console.log('tipoPerfil', tipoPerfil)
                if (tipoPerfil === "cliente") col = col.where('perfisAutorizado.' + perfil.uid, '==', true)
                if (tipoPerfil === "tecnico") col = col.where('perfisAutorizado.' + perfil.uid, '==', true)
                if (tipoPerfil === "lider") {
                    // se mais de 10 clientes, pode ser que precisaremos de uma nova abordagem
                    // existe um limitador de 10 no operador 'in'
                    if (perfil.clientesPermitidos && Array.isArray(perfil.clientesPermitidos) && perfil.clientesPermitidos.length > 0) {
                        col = col.where('uid', 'in', perfil.clientesPermitidos.map(cliente => cliente.uid))
                    }
                }
            }
            return col
        }

        query = extraQuery(query)

        let result = await fetchArray(query.get())
        result = result.map((item, index) => ({
            ...item,
            key: index.toString(),
        }))

        setClienteList([{ nome: "", key: '-1' }, ...result])
    }, [perfil, tipoPerfil])

    useEffect(() => {
        // Carrega ao abrir auto complete.
        if (open && !clienteList.length) {
            loadOptions()
        }
        return () => {

        }
    }, [clienteList.length, loadOptions, open])

    useEffect(() => {
        if (perfil) {
            if (perfil.grupoPermissao) {
                if (perfil.grupoPermissao.uid === "r9jrEQXznNgjrZTGCfch") {
                    setTipoPerfil('admin')
                }
                if (perfil.grupoPermissao.uid === "RECT03jkyTQW9B2OMz47") {
                    setTipoPerfil('tecnico')
                }
                if (perfil.grupoPermissao.uid === "-OXwisN4fkQV3l7Uzeui") {
                    setTipoPerfil('lider')
                }
            }
        }
    }, [perfil, setTipoPerfil])

    return (
        <Field
            name={clienteFieldName}
            validate={(value) => (value && value.length && value.length > 0 ? undefined : 'Campo obrigatório')}
            render={({ input, meta }) => (
                <div style={{ flex: 1 }}>
                    <Autocomplete
                        options={clienteList}
                        getOptionLabel={(option) => option.nome || ''}
                        isOptionEqualToValue={(option, value) => {
                            return option.nome === value.nome && option.uid === value.uid
                        }}
                        //
                        renderOption={(props, option) => (
                            <li {...props} key={option.key || option.uid || option.sequencialIndex}>
                                {option.nome}
                            </li>
                        )}
                        //
                        open={open}
                        onOpen={() => setOpen(true)}
                        onClose={() => setOpen(false)}
                        loading={loading}
                        //
                        sx={{ flex: 1 }}
                        forcePopupIcon={false}
                        renderInput={(params) => {
                            return (
                                <TextField
                                    label="Cliente"
                                    error={meta.error && meta.touched}
                                    helperText={meta.touched ? meta.error : ''}
                                    variant="standard"
                                    {...params}
                                />
                            )
                        }}
                        //
                        onChange={(_, value) => {
                            input.onChange(value)
                            change('fazenda', null)
                            change('tecnico', '')

                            // limpa o agrupador se só tem um cliente selecionado e o agrupador é de Cliente
                            if (value && value.length && value.length === 1 && agrupador && agrupador.includes("Cliente")) {
                                change('agrupador', '')
                            }
                        }}

                        // só pode selecionar 30 clientes, porque é o limite da query
                        getOptionDisabled={(options) => (
                            tipoPerfil === 'admin'
                                ? cliente && cliente.length && cliente.length > 29 // quem é admin seleciona até 30 opções
                                    ? true // desabilita opções
                                    : false
                                : cliente && cliente.length > 0 // quem não é admin só seleciona uma opção
                        )}
                        multiple
                    />
                </div>
            )}
        />
    )
}